// import React, { useState, useEffect } from "react";
// import {
//   Card,
//   Form,
//   Button,
//   Modal,
//   Badge,
//   Spinner,
//   Row,
//   Col,
//   Alert,
// } from "react-bootstrap";
// import { toast } from "react-toastify";
// import { useDropzone } from "react-dropzone";

// import { ContentBlock, Page, PageFormData, SEO } from "interface";
// import {
//   createPage,
//   getAllPagesAdmin,
//   updatePage,
//   deletePage,
//   togglePageStatus,
// } from "api/apis";

// interface ContentBlockWithFile extends ContentBlock {
//   imageFile?: File;
// }

// interface PageFormDataWithFiles extends Omit<PageFormData, "contents"> {
//   contents: ContentBlockWithFile[];
// }

// const CreateNewPage: React.FC = () => {
//   const [pages, setPages] = useState<Page[]>([]);
//   const [loading, setLoading] = useState<boolean>(true);
//   const [showModal, setShowModal] = useState<boolean>(false);
//   const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
//   const [pageToDelete, setPageToDelete] = useState<string | null>(null);
//   const [isEditMode, setIsEditMode] = useState<boolean>(false);
//   const [currentPage, setCurrentPage] = useState<PageFormDataWithFiles>({
//     title: "",
//     contents: [{ sectionTitle: "", text: "", image: "" }],
//     seo: {
//       metaTitle: "",
//       metaDescription: "",
//       keywords: [],
//     },
//   });
//   const [keywordInput, setKeywordInput] = useState<string>("");
//   const [errors, setErrors] = useState<Record<string, string>>({});
//   const [uploading, setUploading] = useState<boolean>(false);

//   // Fetch all pages on component mount
//   useEffect(() => {
//     fetchPages();
//   }, []);

//   const fetchPages = async (): Promise<void> => {
//     try {
//       setLoading(true);
//       const response = await getAllPagesAdmin();
//       setPages(response.pages);
//     } catch (error: any) {
//       toast.error("Failed to fetch pages");
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Toggle page active status
//   const handleToggle = async (
//     id: string,
//     currentActive: boolean
//   ): Promise<void> => {
//     try {
//       const response = await togglePageStatus(id);
//       toast.success(`Page is now ${response.isActive ? "active" : "inactive"}`);

//       setPages(
//         pages.map((page) =>
//           page._id === id ? { ...page, isActive: response.isActive } : page
//         )
//       );
//     } catch (error: any) {
//       toast.error("Failed to update page status");
//       console.error(error);
//     }
//   };

//   // Show delete confirmation modal
//   const confirmDelete = (id: string): void => {
//     setPageToDelete(id);
//     setShowDeleteModal(true);
//   };

//   // Delete a page after confirmation
//   const handleDelete = async (): Promise<void> => {
//     if (!pageToDelete) return;

//     try {
//       await deletePage(pageToDelete);
//       setPages(pages.filter((page) => page._id !== pageToDelete));
//       toast.success("Page deleted successfully");
//       setShowDeleteModal(false);
//       setPageToDelete(null);
//     } catch (error: any) {
//       toast.error("Failed to delete page");
//       console.error(error);
//     }
//   };

//   // Open modal for editing a page
//   const handleEdit = (page: Page): void => {
//     setIsEditMode(true);
//     setCurrentPage({
//       _id: page._id,
//       title: page.title,
//       contents: page.contents.map((content) => ({
//         ...content,
//         imageFile: undefined,
//       })),
//       seo: page.seo,
//       isActive: page.isActive,
//     });
//     setKeywordInput("");
//     setErrors({});
//     setShowModal(true);
//   };

//   // Open modal for adding a new page
//   const handleAddPage = (): void => {
//     setIsEditMode(false);
//     setCurrentPage({
//       title: "",
//       contents: [{ sectionTitle: "", text: "", image: "" }],
//       seo: {
//         metaTitle: "",
//         metaDescription: "",
//         keywords: [],
//       },
//     });
//     setKeywordInput("");
//     setErrors({});
//     setShowModal(true);
//   };

//   // Handle form input changes
//   const handleInputChange = (
//     e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
//   ): void => {
//     const { name, value } = e.target;

//     if (name.startsWith("seo.")) {
//       const seoField = name.split(".")[1] as keyof SEO;
//       setCurrentPage((prev) => ({
//         ...prev,
//         seo: {
//           ...prev.seo,
//           [seoField]: value,
//         },
//       }));
//     } else {
//       setCurrentPage((prev) => ({
//         ...prev,
//         [name]: value,
//       }));
//     }

//     // Clear error when field is updated
//     if (errors[name]) {
//       setErrors((prev) => {
//         const newErrors = { ...prev };
//         delete newErrors[name];
//         return newErrors;
//       });
//     }
//   };

//   // Handle content block changes
//   const handleContentChange = (
//     index: number,
//     field: keyof ContentBlock,
//     value: string
//   ): void => {
//     const updatedContents = [...currentPage.contents];
//     updatedContents[index] = {
//       ...updatedContents[index],
//       [field]: value,
//     };

//     setCurrentPage((prev) => ({
//       ...prev,
//       contents: updatedContents,
//     }));

//     // Clear error when field is updated
//     const errorKey = `contents[${index}].${field}`;
//     if (errors[errorKey]) {
//       setErrors((prev) => {
//         const newErrors = { ...prev };
//         delete newErrors[errorKey];
//         return newErrors;
//       });
//     }
//   };

//   // Handle image file upload
//   const handleImageUpload = (index: number, file: File): void => {
//     const updatedContents = [...currentPage.contents];
//     updatedContents[index] = {
//       ...updatedContents[index],
//       imageFile: file,
//       image: URL.createObjectURL(file), // Create preview URL
//     };

//     setCurrentPage((prev) => ({
//       ...prev,
//       contents: updatedContents,
//     }));
//   };

//   // Add a new content block
//   const addContentBlock = (): void => {
//     setCurrentPage((prev) => ({
//       ...prev,
//       contents: [...prev.contents, { sectionTitle: "", text: "", image: "" }],
//     }));
//   };

//   // Remove a content block
//   const removeContentBlock = (index: number): void => {
//     if (currentPage.contents.length > 1) {
//       const updatedContents = [...currentPage.contents];
//       updatedContents.splice(index, 1);

//       setCurrentPage((prev) => ({
//         ...prev,
//         contents: updatedContents,
//       }));

//       // Clear errors for this content block
//       setErrors((prev) => {
//         const newErrors = { ...prev };
//         Object.keys(newErrors).forEach((key) => {
//           if (key.startsWith(`contents[${index}]`)) {
//             delete newErrors[key];
//           }
//         });
//         return newErrors;
//       });
//     }
//   };

//   // Add a keyword
//   const addKeyword = (): void => {
//     if (
//       keywordInput.trim() &&
//       !currentPage.seo.keywords.includes(keywordInput.trim())
//     ) {
//       setCurrentPage((prev) => ({
//         ...prev,
//         seo: {
//           ...prev.seo,
//           keywords: [...prev.seo.keywords, keywordInput.trim()],
//         },
//       }));
//       setKeywordInput("");
//     }
//   };

//   // Remove a keyword
//   const removeKeyword = (keywordToRemove: string): void => {
//     setCurrentPage((prev) => ({
//       ...prev,
//       seo: {
//         ...prev.seo,
//         keywords: prev.seo.keywords.filter((k) => k !== keywordToRemove),
//       },
//     }));
//   };

//   // Handle keyword input key press
//   const handleKeywordKeyPress = (e: React.KeyboardEvent): void => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//       addKeyword();
//     }
//   };

//   // Validate form
//   const validateForm = (): boolean => {
//     const newErrors: Record<string, string> = {};

//     // Validate title
//     if (!currentPage.title.trim()) {
//       newErrors.title = "Title is required";
//     }

//     // Validate contents
//     currentPage.contents.forEach((content, index) => {
//       if (!content.sectionTitle.trim()) {
//         newErrors[`contents[${index}].sectionTitle`] =
//           "Section title is required";
//       }
//       if (!content.text.trim()) {
//         newErrors[`contents[${index}].text`] = "Text content is required";
//       }
//     });

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // Prepare form data for submission
//   // Prepare form data for submission
//   const prepareFormData = (): FormData => {
//     const formData = new FormData();

//     // Add basic fields
//     formData.append("title", currentPage.title);
//     formData.append("seo", JSON.stringify(currentPage.seo));

//     // Prepare contents data - convert to JSON string
//     const contentsData = currentPage.contents.map((content, index) => ({
//       sectionTitle: content.sectionTitle,
//       text: content.text,
//       image: content.image, // Keep existing image URL
//       // Note: We don't include imageFile here as it will be sent as separate form data
//     }));
//     formData.append("contents", JSON.stringify(contentsData));

//     // Add image files with their corresponding indexes
//     currentPage.contents.forEach((content, index) => {
//       if (content.imageFile) {
//         formData.append(`image-${index}`, content.imageFile);
//       }
//     });

//     // Add isActive status if editing
//     if (isEditMode && currentPage._id && currentPage.isActive !== undefined) {
//       formData.append("isActive", currentPage.isActive.toString());
//     }

//     return formData;
//   };

//   // Submit the form (create or update)
//   const handleSubmit = async (): Promise<void> => {
//     if (!validateForm()) {
//       toast.error("Please fix the form errors");
//       return;
//     }

//     try {
//       setUploading(true);
//       const formData = prepareFormData();

//       if (isEditMode && currentPage._id) {
//         await updatePage(currentPage._id, formData);
//         toast.success("Page updated successfully");
//       } else {
//         await createPage(formData);
//         toast.success("Page created successfully");
//       }

//       setShowModal(false);
//       fetchPages(); // Refresh the list
//     } catch (error: any) {
//       toast.error(
//         error.response?.data?.error ||
//           (isEditMode ? "Failed to update page" : "Failed to create page")
//       );
//       console.error(error);
//     } finally {
//       setUploading(false);
//     }
//   };

//   // Custom dropzone component for image uploads
//   const ImageUploadDropzone: React.FC<{ index: number }> = ({ index }) => {
//     const onDrop = (acceptedFiles: File[]) => {
//       if (acceptedFiles.length > 0) {
//         handleImageUpload(index, acceptedFiles[0]);
//       }
//     };

//     const { getRootProps, getInputProps, isDragActive } = useDropzone({
//       onDrop,
//       accept: {
//         "image/*": [".jpeg", ".jpg", ".png", ".gif", ".webp"],
//       },
//       maxFiles: 1,
//     });

//     return (
//       <div
//         {...getRootProps()}
//         className="border rounded p-3 text-center"
//         style={{
//           borderStyle: "dashed",
//           cursor: "pointer",
//           backgroundColor: isDragActive ? "#f8f9fa" : "transparent",
//         }}
//       >
//         <input {...getInputProps()} />
//         {currentPage.contents[index].image ? (
//           <div>
//             <img
//               src={currentPage.contents[index].image}
//               alt="Preview"
//               style={{
//                 width: "150px",
//                 height: "auto",
//                 borderRadius: "5px",
//                 marginBottom: "10px",
//               }}
//             />
//             <p className="text-muted small">Click or drag to replace image</p>
//           </div>
//         ) : (
//           <div>
//             <p>
//               {isDragActive
//                 ? "Drop the image here"
//                 : "Drag & drop an image here, or click to select"}
//             </p>
//             <p className="text-muted small">Supports: JPG, PNG, GIF, WebP</p>
//           </div>
//         )}
//       </div>
//     );
//   };

//   if (loading) {
//     return (
//       <div className="text-center py-5">
//         <Spinner animation="border" variant="primary" />
//         <p className="mt-2">Loading pages...</p>
//       </div>
//     );
//   }

//   return (
//     <div
//       className="container-fluid"
//       style={{ marginTop: "8rem", padding: "0 1rem" }}
//     >
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h2>Pages Management</h2>
//         <Button variant="primary" onClick={handleAddPage}>
//           Add New Page
//         </Button>
//       </div>

//       {pages.length === 0 ? (
//         <Card className="text-center py-5">
//           <Card.Body>
//             <h5>No pages found</h5>
//             <p className="text-muted">
//               Get started by creating your first page
//             </p>
//             <Button variant="primary" onClick={handleAddPage}>
//               Create Your First Page
//             </Button>
//           </Card.Body>
//         </Card>
//       ) : (
//         <Row>
//           {pages.map((page) => (
//             <Col key={page._id} md={6} lg={4} className="mb-4">
//               <Card className="h-100">
//                 <Card.Body className="d-flex flex-column">
//                   <div className="d-flex justify-content-between align-items-start mb-2">
//                     <Card.Title>{page.title}</Card.Title>
//                     <Badge bg={page.isActive ? "success" : "secondary"}>
//                       {page.isActive ? "Active" : "Inactive"}
//                     </Badge>
//                   </div>

//                   <Card.Text className="text-muted small mb-2">
//                     Slug: {page.slug}
//                   </Card.Text>

//                   <Card.Text className="flex-grow-1">
//                     {page.contents.length} content blocks
//                   </Card.Text>

//                   <div className="d-flex justify-content-between align-items-center mt-auto">
//                     <Form.Check
//                       type="switch"
//                       id={`toggle-${page._id}`}
//                       label={page.isActive ? "Active" : "Inactive"}
//                       checked={page.isActive}
//                       onChange={() => handleToggle(page._id, page.isActive)}
//                     />

//                     <div>
//                       <Button
//                         variant="outline-primary"
//                         size="sm"
//                         className="me-2"
//                         onClick={() => handleEdit(page)}
//                       >
//                         Edit
//                       </Button>
//                       <Button
//                         variant="outline-danger"
//                         size="sm"
//                         onClick={() => confirmDelete(page._id)}
//                       >
//                         Delete
//                       </Button>
//                     </div>
//                   </div>
//                 </Card.Body>
//                 <Card.Footer className="text-muted small">
//                   Created: {new Date(page.createdAt).toLocaleDateString()}
//                 </Card.Footer>
//               </Card>
//             </Col>
//           ))}
//         </Row>
//       )}

//       {/* Page Modal */}
//       <Modal
//         show={showModal}
//         onHide={() => setShowModal(false)}
//         size="xl"
//         scrollable
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>{isEditMode ? "Edit Page" : "Add New Page"}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="pageTitle" className="mb-3">
//               <Form.Label>Title *</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="title"
//                 value={currentPage.title}
//                 onChange={handleInputChange}
//                 placeholder="Enter page title"
//                 isInvalid={!!errors.title}
//               />
//               <Form.Control.Feedback type="invalid">
//                 {errors.title}
//               </Form.Control.Feedback>
//             </Form.Group>

//             <hr />
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               <h5>Content Blocks</h5>
//               <Button
//                 variant="outline-primary"
//                 size="sm"
//                 onClick={addContentBlock}
//               >
//                 Add Content Block
//               </Button>
//             </div>

//             {currentPage.contents.map((content, index) => (
//               <div key={index} className="border p-3 mb-3 rounded">
//                 <div className="d-flex justify-content-between align-items-center mb-2">
//                   <h6>Content Block #{index + 1}</h6>
//                   {currentPage.contents.length > 1 && (
//                     <Button
//                       variant="outline-danger"
//                       size="sm"
//                       onClick={() => removeContentBlock(index)}
//                     >
//                       Remove
//                     </Button>
//                   )}
//                 </div>

//                 <Form.Group className="mb-3">
//                   <Form.Label>Section Title *</Form.Label>
//                   <Form.Control
//                     type="text"
//                     value={content.sectionTitle}
//                     onChange={(e) =>
//                       handleContentChange(index, "sectionTitle", e.target.value)
//                     }
//                     placeholder="Enter section title"
//                     isInvalid={!!errors[`contents[${index}].sectionTitle`]}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors[`contents[${index}].sectionTitle`]}
//                   </Form.Control.Feedback>
//                 </Form.Group>

//                 <Form.Group className="mb-3">
//                   <Form.Label>Text Content *</Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     value={content.text}
//                     onChange={(e) =>
//                       handleContentChange(index, "text", e.target.value)
//                     }
//                     placeholder="Enter text content"
//                     isInvalid={!!errors[`contents[${index}].text`]}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors[`contents[${index}].text`]}
//                   </Form.Control.Feedback>
//                 </Form.Group>

//                 <Form.Group className="mb-3">
//                   <Form.Label>Upload Image</Form.Label>
//                   <ImageUploadDropzone index={index} />
//                 </Form.Group>
//               </div>
//             ))}

//             <hr />
//             <h5 className="mb-3">SEO Settings</h5>

//             <Form.Group className="mb-3">
//               <Form.Label>Meta Title</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="seo.metaTitle"
//                 value={currentPage.seo.metaTitle}
//                 onChange={handleInputChange}
//                 placeholder="Enter meta title for SEO"
//               />
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label>Meta Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={2}
//                 name="seo.metaDescription"
//                 value={currentPage.seo.metaDescription}
//                 onChange={handleInputChange}
//                 placeholder="Enter meta description for SEO"
//               />
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label>Keywords</Form.Label>
//               <div className="d-flex mb-2">
//                 <Form.Control
//                   type="text"
//                   value={keywordInput}
//                   onChange={(e) => setKeywordInput(e.target.value)}
//                   onKeyPress={handleKeywordKeyPress}
//                   placeholder="Enter a keyword and press Enter or click Add"
//                 />
//                 <Button
//                   variant="outline-secondary"
//                   onClick={addKeyword}
//                   className="ms-2"
//                 >
//                   Add
//                 </Button>
//               </div>

//               <div>
//                 {currentPage.seo.keywords.map((keyword, idx) => (
//                   <Badge
//                     key={idx}
//                     bg="primary"
//                     className="me-2 mb-2 p-2"
//                     style={{ cursor: "pointer" }}
//                     onClick={() => removeKeyword(keyword)}
//                   >
//                     {keyword} ×
//                   </Badge>
//                 ))}
//               </div>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleSubmit} disabled={uploading}>
//             {uploading ? (
//               <>
//                 <Spinner animation="border" size="sm" className="me-2" />
//                 {isEditMode ? "Updating..." : "Creating..."}
//               </>
//             ) : (
//               `${isEditMode ? "Update" : "Create"} Page`
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete Confirmation Modal */}
//       <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Deletion</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to delete this page? This action cannot be
//           undone.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="danger" onClick={handleDelete}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default CreateNewPage;

import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Button,
  Modal,
  Badge,
  Spinner,
  Row,
  Col,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { useDropzone } from "react-dropzone";

import { ContentBlock, Page, PageFormData, SEO } from "interface";
import {
  createPage,
  getAllPagesAdmin,
  updatePage,
  deletePage,
  togglePageStatus,
} from "api/apis";

interface ContentBlockWithFile extends ContentBlock {
  imageFile?: File;
}

interface PageFormDataWithFiles extends Omit<PageFormData, "contents"> {
  contents: ContentBlockWithFile[];
}

const CreateNewPage: React.FC = () => {
  const [pages, setPages] = useState<Page[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [pageToDelete, setPageToDelete] = useState<string | null>(null);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<PageFormDataWithFiles>({
    title: "",
    header: "", // Add this line
    contents: [{ sectionTitle: "", text: "", image: "" }],
    seo: {
      metaTitle: "",
      metaDescription: "",
      keywords: [],
      category: "",
    },
  });
  const [keywordInput, setKeywordInput] = useState<string>("");
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [uploading, setUploading] = useState<boolean>(false);
  document.title = "Pages";

  // Fetch all pages on component mount
  useEffect(() => {
    fetchPages();
  }, []);

  const fetchPages = async (): Promise<void> => {
    try {
      setLoading(true);
      const response = await getAllPagesAdmin();
      setPages(response.pages);
    } catch (error: any) {
      toast.error("Failed to fetch pages");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Toggle page active status
  const handleToggle = async (
    id: string,
    currentActive: boolean
  ): Promise<void> => {
    try {
      const response = await togglePageStatus(id);
      toast.success(`Page is now ${response.isActive ? "active" : "inactive"}`);

      setPages(
        pages.map((page) =>
          page._id === id ? { ...page, isActive: response.isActive } : page
        )
      );
    } catch (error: any) {
      toast.error("Failed to update page status");
      console.error(error);
    }
  };

  // Show delete confirmation modal
  const confirmDelete = (id: string): void => {
    setPageToDelete(id);
    setShowDeleteModal(true);
  };

  // Delete a page after confirmation
  const handleDelete = async (): Promise<void> => {
    if (!pageToDelete) return;

    try {
      await deletePage(pageToDelete);
      setPages(pages.filter((page) => page._id !== pageToDelete));
      toast.success("Page deleted successfully");
      setShowDeleteModal(false);
      setPageToDelete(null);
    } catch (error: any) {
      toast.error("Failed to delete page");
      console.error(error);
    }
  };

  // Open modal for editing a page
  const handleEdit = (page: Page): void => {
    setIsEditMode(true);
    setCurrentPage({
      _id: page._id,
      title: page.title,
      header: page.header || "", // Add this line to populate existing header
      contents: page.contents.map((content) => ({
        ...content,
        imageFile: undefined,
      })),
      seo: page.seo,
      isActive: page.isActive,
    });
    setKeywordInput("");
    setErrors({});
    setShowModal(true);
  };

  // Open modal for adding a new page
  const handleAddPage = (): void => {
    setIsEditMode(false);
    setCurrentPage({
      title: "",
      contents: [{ sectionTitle: "", text: "", image: "" }],
      seo: {
        metaTitle: "",
        metaDescription: "",
        keywords: [],
        category: "",
      },
    });
    setKeywordInput("");
    setErrors({});
    setShowModal(true);
  };

  // Handle form input changes
  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ): void => {
    const { name, value } = e.target;

    if (name.startsWith("seo.")) {
      const seoField = name.split(".")[1] as keyof SEO;
      setCurrentPage((prev) => ({
        ...prev,
        seo: {
          ...prev.seo,
          [seoField]: value,
        },
      }));
    } else {
      setCurrentPage((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Clear error when field is updated
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  // Handle content block changes
  const handleContentChange = (
    index: number,
    field: keyof ContentBlock,
    value: string
  ): void => {
    const updatedContents = [...currentPage.contents];
    updatedContents[index] = {
      ...updatedContents[index],
      [field]: value,
    };

    setCurrentPage((prev) => ({
      ...prev,
      contents: updatedContents,
    }));

    // Clear error when field is updated
    const errorKey = `contents[${index}].${field}`;
    if (errors[errorKey]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[errorKey];
        return newErrors;
      });
    }
  };

  // Convert image file to base64
  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  // Handle image file upload
  const handleImageUpload = async (
    index: number,
    file: File
  ): Promise<void> => {
    try {
      const base64Image = await fileToBase64(file);

      const updatedContents = [...currentPage.contents];
      updatedContents[index] = {
        ...updatedContents[index],
        imageFile: file,
        image: base64Image, // Store as base64 string
      };

      setCurrentPage((prev) => ({
        ...prev,
        contents: updatedContents,
      }));
    } catch (error) {
      toast.error("Failed to process image");
      console.error(error);
    }
  };

  // Add a new content block
  const addContentBlock = (): void => {
    setCurrentPage((prev) => ({
      ...prev,
      contents: [...prev.contents, { sectionTitle: "", text: "", image: "" }],
    }));
  };

  // Remove a content block
  const removeContentBlock = (index: number): void => {
    if (currentPage.contents.length > 1) {
      const updatedContents = [...currentPage.contents];
      updatedContents.splice(index, 1);

      setCurrentPage((prev) => ({
        ...prev,
        contents: updatedContents,
      }));

      // Clear errors for this content block
      setErrors((prev) => {
        const newErrors = { ...prev };
        Object.keys(newErrors).forEach((key) => {
          if (key.startsWith(`contents[${index}]`)) {
            delete newErrors[key];
          }
        });
        return newErrors;
      });
    }
  };

  // Add a keyword
  const addKeyword = (): void => {
    if (
      keywordInput.trim() &&
      !currentPage.seo.keywords.includes(keywordInput.trim())
    ) {
      setCurrentPage((prev) => ({
        ...prev,
        seo: {
          ...prev.seo,
          keywords: [...prev.seo.keywords, keywordInput.trim()],
        },
      }));
      setKeywordInput("");
    }
  };

  // Remove a keyword
  const removeKeyword = (keywordToRemove: string): void => {
    setCurrentPage((prev) => ({
      ...prev,
      seo: {
        ...prev.seo,
        keywords: prev.seo.keywords.filter((k) => k !== keywordToRemove),
      },
    }));
  };

  // Handle keyword input key press
  const handleKeywordKeyPress = (e: React.KeyboardEvent): void => {
    if (e.key === "Enter") {
      e.preventDefault();
      addKeyword();
    }
  };

  // Validate form
  const validateForm = (): boolean => {
    const newErrors: Record<string, string> = {};

    // Validate title
    if (!currentPage.title.trim()) {
      newErrors.title = "Title is required";
    }

    // Validate header
    // if (!currentPage.header?.trim()) {
    //   newErrors.header = "Header is required"; // Add this validation
    // }

    // Validate contents
    currentPage.contents.forEach((content, index) => {
      if (!content.sectionTitle.trim()) {
        newErrors[`contents[${index}].sectionTitle`] =
          "Section title is required";
      }
      if (!content.text.trim()) {
        newErrors[`contents[${index}].text`] = "Text content is required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Prepare data for submission
  const prepareData = () => {
    // Remove imageFile property as we don't need to send it
    const contentsWithoutFiles = currentPage.contents.map((content) => {
      const { imageFile, ...rest } = content;
      return rest;
    });

    // Debug: Check what data is being prepared
    console.log("Preparing data:", {
      title: currentPage.title,
      header: currentPage.header, // This should show the selected header
      contents: contentsWithoutFiles,
      seo: currentPage.seo,
    });

    return {
      title: currentPage.title,
      header: currentPage.header, // Make sure this line is included
      contents: contentsWithoutFiles,
      seo: currentPage.seo,
      ...(isEditMode &&
        currentPage._id && {
          _id: currentPage._id,
          isActive: currentPage.isActive,
        }),
    };
  };

  // Submit the form (create or update)
  const handleSubmit = async (): Promise<void> => {
    if (!validateForm()) {
      toast.error("Please fix the form errors");
      return;
    }

    try {
      setUploading(true);
      const data = prepareData();

      // Debug: Check what's being sent to the API
      console.log("Submitting data to API:", data);
      console.log("Header value being sent:", data.header);

      if (isEditMode && currentPage._id) {
        await updatePage(currentPage._id, data);
        toast.success("Page updated successfully");
      } else {
        await createPage(data);
        toast.success("Page created successfully");
      }

      setShowModal(false);
      fetchPages(); // Refresh the list
    } catch (error: any) {
      console.error("API Error:", error);
      console.error("Error response:", error.response);
      toast.error(
        error.response?.data?.error ||
          (isEditMode ? "Failed to update page" : "Failed to create page")
      );
    } finally {
      setUploading(false);
    }
  };

  // Custom dropzone component for image uploads
  const ImageUploadDropzone: React.FC<{ index: number }> = ({ index }) => {
    const onDrop = (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        handleImageUpload(index, acceptedFiles[0]);
      }
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
      accept: {
        "image/*": [".jpeg", ".jpg", ".png", ".gif", ".webp"],
      },
      maxFiles: 1,
    });

    return (
      <div
        {...getRootProps()}
        className="border rounded p-3 text-center"
        style={{
          borderStyle: "dashed",
          cursor: "pointer",
          backgroundColor: isDragActive ? "#f8f9fa" : "transparent",
        }}
      >
        <input {...getInputProps()} />
        {currentPage.contents[index].image ? (
          <div>
            <img
              src={currentPage.contents[index].image}
              alt="Preview"
              style={{
                width: "150px",
                height: "auto",
                borderRadius: "5px",
                marginBottom: "10px",
              }}
            />
            <p className="text-muted small">Click or drag to replace image</p>
          </div>
        ) : (
          <div>
            <p>
              {isDragActive
                ? "Drop the image here"
                : "Drag & drop an image here, or click to select"}
            </p>
            <p className="text-muted small">Supports: JPG, PNG, GIF, WebP</p>
          </div>
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading pages...</p>
      </div>
    );
  }

  return (
    <div
      className="container-fluid"
      style={{ marginTop: "8rem", padding: "0 1rem" }}
    >
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Pages Management</h2>
        <Button variant="primary" onClick={handleAddPage}>
          Add New Page
        </Button>
      </div>

      {pages.length === 0 ? (
        <Card className="text-center py-5">
          <Card.Body>
            <h5>No pages found</h5>
            <p className="text-muted">
              Get started by creating your first page
            </p>
            <Button variant="primary" onClick={handleAddPage}>
              Create Your First Page
            </Button>
          </Card.Body>
        </Card>
      ) : (
        <Row>
          {pages.map((page) => (
            <Col key={page._id} md={6} lg={4} className="mb-4">
              <Card className="h-100">
                <Card.Body className="d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <Card.Title>{page.title}</Card.Title>
                    <Badge bg={page.isActive ? "success" : "secondary"}>
                      {page.isActive ? "Active" : "Inactive"}
                    </Badge>
                  </div>

                  <Card.Text className="text-muted small mb-2">
                    Slug: {page.slug}
                  </Card.Text>

                  <Card.Text className="flex-grow-1">
                    {page.contents.length} content blocks
                  </Card.Text>

                  <div className="d-flex justify-content-between align-items-center mt-auto">
                    <Form.Check
                      type="switch"
                      id={`toggle-${page._id}`}
                      label={page.isActive ? "Active" : "Inactive"}
                      checked={page.isActive}
                      onChange={() => handleToggle(page._id, page.isActive)}
                    />

                    <div>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="me-2"
                        onClick={() => handleEdit(page)}
                      >
                        Edit
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => confirmDelete(page._id)}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                </Card.Body>
                <Card.Footer className="text-muted small">
                  Created: {new Date(page.createdAt).toLocaleDateString()}
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      {/* Page Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{isEditMode ? "Edit Page" : "Add New Page"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="pageTitle" className="mb-3">
              <Form.Label>Title *</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={currentPage.title}
                onChange={handleInputChange}
                placeholder="Enter page title"
                isInvalid={!!errors.title}
              />
              <Form.Control.Feedback type="invalid">
                {errors.title}
              </Form.Control.Feedback>
            </Form.Group>

            <hr />
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Content Blocks</h5>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={addContentBlock}
              >
                Add Content Block
              </Button>
            </div>

            {currentPage.contents.map((content, index) => (
              <div key={index} className="border p-3 mb-3 rounded">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6>Content Block #{index + 1}</h6>
                  {currentPage.contents.length > 1 && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => removeContentBlock(index)}
                    >
                      Remove
                    </Button>
                  )}
                </div>

                <Form.Group className="mb-3">
                  <Form.Label>Section Title *</Form.Label>
                  <Form.Control
                    type="text"
                    value={content.sectionTitle}
                    onChange={(e) =>
                      handleContentChange(index, "sectionTitle", e.target.value)
                    }
                    placeholder="Enter section title"
                    isInvalid={!!errors[`contents[${index}].sectionTitle`]}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors[`contents[${index}].sectionTitle`]}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Text Content *</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={content.text}
                    onChange={(e) =>
                      handleContentChange(index, "text", e.target.value)
                    }
                    placeholder="Enter text content"
                    isInvalid={!!errors[`contents[${index}].text`]}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors[`contents[${index}].text`]}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Upload Image</Form.Label>
                  <ImageUploadDropzone index={index} />
                </Form.Group>
              </div>
            ))}

            <hr />
            <h5 className="mb-3">SEO Settings</h5>

            <Form.Group className="mb-3">
              <Form.Label>Meta Title</Form.Label>
              <Form.Control
                type="text"
                name="seo.metaTitle"
                value={currentPage.seo.metaTitle}
                onChange={handleInputChange}
                placeholder="Enter meta title for SEO"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Meta Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name="seo.metaDescription"
                value={currentPage.seo.metaDescription}
                onChange={handleInputChange}
                placeholder="Enter meta description for SEO"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Keywords</Form.Label>
              <div className="d-flex mb-2">
                <Form.Control
                  type="text"
                  value={keywordInput}
                  onChange={(e) => setKeywordInput(e.target.value)}
                  onKeyPress={handleKeywordKeyPress}
                  placeholder="Enter a keyword and press Enter or click Add"
                />
                <Button
                  variant="outline-secondary"
                  onClick={addKeyword}
                  className="ms-2"
                >
                  Add
                </Button>
              </div>

              <div>
                {currentPage.seo.keywords.map((keyword, idx) => (
                  <Badge
                    key={idx}
                    bg="primary"
                    className="me-2 mb-2 p-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => removeKeyword(keyword)}
                  >
                    {keyword} ×
                  </Badge>
                ))}
              </div>
            </Form.Group>

            {/* 🔽 New Dropdown Section */}
            <Form.Group controlId="pageHeader" className="mb-3">
              <Form.Label>Header</Form.Label>
              <Form.Select
                name="header"
                value={currentPage.header || ""}
                onChange={handleInputChange}
                isInvalid={!!errors.header}
              >
                <option value="">-- Select Header --</option>
                <option value="About Us">About Us</option>
                <option value="Our Collections">Our Collections</option>
                <option value="Investor Relation">Investor Relation</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.header}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={uploading}>
            {uploading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                {isEditMode ? "Updating..." : "Creating..."}
              </>
            ) : (
              `${isEditMode ? "Update" : "Create"} Page`
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this page? This action cannot be
          undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreateNewPage;
